import axios from 'axios'

const SYSTEM = {
    base: "/system",
    login: "/login"
};

const ESP = {
    base: "/ESP",
    locationList: "/ListarPoblacion",
    normalizeAddress: "/NormalizarDomicilio"
};

const HEADERS = {
    headers: {
        codSesion: ""
    }
};

const CTI_AXIOS = axios.create({
    baseURL: process.env.VUE_APP_CTI_URL
});

const buildUrl = (module, endpoint) => {
    return `${process.env.VUE_APP_CTI_SERVICE_URL}${module.base}${endpoint}`;
}


export default class CTIService {

    async login() {
        const response = await CTI_AXIOS.post(buildUrl(SYSTEM, SYSTEM.login), {
            userName: process.env.VUE_APP_CTI_USER,
            userAccess: process.env.VUE_APP_CTI_USER_ACCESS,
            userService: process.env.VUE_APP_CTI_USER_SERVICE
        });
        HEADERS.headers.codSesion = `${response.data.userToken}@${response.data.userDomain}`;
    }

    locationListByProvinceAndPattern(provinceCode, pattern) {
        return CTI_AXIOS.post(
            buildUrl(ESP, ESP.locationList),
            {
                codProvincia: provinceCode,
                patron: pattern
            },
            HEADERS);
    }

    normalizeAddress(province, location, postalCode, typeOfRoad, address) {
        return CTI_AXIOS.get(
            buildUrl(ESP, ESP.normalizeAddress),
            {
                params: {
                    codProvincia: province,
                    desPoblacion: location,
                    codPostal: postalCode,
                    tipoVia: typeOfRoad,
                    desVia: address
                },
                headers: HEADERS.headers
            });
    }

}
